$(document).ready(function(e){
  $("path").each(function(e) {
    if ($(this).data('info') == ""){
      $(this).attr('fill', '#eee');
      $(this).css('pointer-events', 'none');
    }
  });
  if ($(window).width() >= 769){
    $("path").hover(function(e) {
      if ($(this).data('info') != ""){
        $('#info-box').css('display','block');
      }
      $('#info-box').html($(this).data('info'));
    });
  }
  $("path").on('click', function(){
    var url = $(this).data('url');
    window.location.href = url;
  });
  $("#mobile-dist-list a").each(function() {
    if ($(this).attr('href') != ""){
      $(this).css('display', 'block');
    }
  });
  $("path").mouseleave(function(e) {
    $('#info-box').css('display','none');
  });
  $(document).mousemove(function(e) {
    $('#info-box').css('top',e.pageY+$('#info-box').height());
    $('#info-box').css('left',e.pageX-($('#info-box').width())/2);
  }).mouseover();
});

